// Api
import Starlight from 'Starlight'

// Constants
import { SITE_KEYWORDS } from 'constants/tags'

// Components
import Layout from 'components/Layout'
import Contact from 'components/Contact'


const Contato = ({ contact, header, footer }) => (
  <Layout
    footer={footer}
    header={header}
    metaTags={{
      title: 'JS Studio | Contato',
      keywords: contact?.data?.data?.metatag_keywords ?? SITE_KEYWORDS
    }}
  >
    <Contact contact={contact.data} />
  </Layout>
)

export async function getStaticProps() {
  const contact = await Starlight.singletons.get('contact')

  return { 
    props: {
      contact: contact || { },
    }
  }
}

export default Contato
